export default [
    {
      path: '/rent/v2/mAboutUs',
      name: 'mAboutUs',
      component: () => import('@/pages/mAboutUs/index'),
      meta: { title: '关于我们', requireAuth: true },
    },
  ]



// WEBPACK FOOTER //
// ./src/pages/mAboutUs/mAboutUs.js